<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('cm_fixed_assets.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="showExport = true">
                        {{ $t('cm_fixed_assets.export') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="showExport" persistent max-width="90%" style="width: 500px !important;">
                <v-card style="width:500px !important">
                    <v-card-title class="justify-center mt-4">
                        <v-row align="center" justify="center" class="my-2">
                            <label style="font-size: 16px; font-weight: bold;" class="blue_accent--text text-uppercase">{{$t('cm_fixed_assets.export_data')}}</label>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-0 my-0 text-center">
                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu2" :model="report.initial_date" :label="$t('cm_fixed_assets.initial_date')" @model="updateDate($event)" :rules_required="rules_required"></datepicker>
                            </v-col>

                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu3" :model="report.final_date" :label="$t('cm_fixed_assets.final_date')" @model="updateDateFinal($event)" :rules_required="rules_required"></datepicker>
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="showExport = false">{{ $t('cm_fixed_assets.cancel') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="exportData">
                                {{ $t('cm_fixed_assets.export') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('cm_fixed_assets.id'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.number'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.date'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.key'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.contry_origin'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.merchandise_data'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.rate'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.guide'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.commercial_invoice'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.electronic_notice'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.sale_order'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.model'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.serial_number'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.fa'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('cm_fixed_assets.crossing_date'), align: "center", value: 'sku', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            report:{
                initial_date: '',
                final_date: ''
            },
            menu2: false,
            menu3: false,
            showExport: false
        }
    },
    mounted(){
        // this.index();
        this.$store.state.module = "headers.cm_fixed_assets";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        updateDate(newDate){
            this.report.initial_date = newDate;
        },
        updateDateFinal(date){
            this.report.final_date = date;
        },
        index(){
            // this.props.items = [];
            // this.$store.state.loaderProps.visible = true;
            // const lsToken = localStorage.getItem("access_token");
            // this.$http.get(this.$store.state.chronosApi + 'cm_fixed_assets', {headers: {Authorization: lsToken}})
            // .then((response) => {
            //     console.log(response);
            // })
            // .catch((response) => {
            //     this.$store.state.loaderProps.visible = false;
            //     if(response.status !== 200){
            //         this.snackbar = {
            //             visible: true,
            //             color: 'red',
            //             text: this.$t('pendings.responses.error')
            //         }
            //     }
            // }).finally(() => {
            //     this.$store.state.loaderProps.visible = false;
            // });
        },
        exportData(){

        }
    }
}
</script>

<style>
</style>